export default __webpack_public_path__ + "static/media/flag-european-union.8839a3ad.svg";